<template>
  <v-app>
    <v-main>
      <v-container class="fill-height justify-center align-center" fluid>
        <div class="text-center">
          <p>{{ error }}</p>
          <v-btn class="mt-5" color="primary" variant="tonal" to="/">Return Home</v-btn>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
const props = defineProps({
  error: Object
})

const handleError = () => clearError({ redirect: '/' })
</script>
